<script setup lang="ts">
import type { IFormSelectInputOption } from '@modules/forms/types';
import type { IRolesNamespaces } from '@modules/roles-and-permissions/types';
import { ERouteNamespace } from '@modules/core/services/router/enums';
import VFormSelectInput from '@modules/forms/components/inputs/VFormSelectInput/VFormSelectInput.vue';
import { useRolesAndPermissionsTranslate } from '@modules/roles-and-permissions/composables';

import type { INamespaceDropdownEmits } from './types';

const emit = defineEmits<INamespaceDropdownEmits>();

const { translate } = useRolesAndPermissionsTranslate();

const namespaces: IRolesNamespaces[] = [ERouteNamespace.ADMIN, ERouteNamespace.AFFILIATE];

const options: IFormSelectInputOption<IRolesNamespaces>[] = namespaces.map((val) => ({ value: val, label: String(val) }));

function handleChange(value?: IRolesNamespaces): void {
  if (value) {
    emit('change', value);
  }
}
</script>

<template>
  <VFormSelectInput v-data-qa-auto-id="'VNamespaceDropdown'"
    :label="translate('NAMESPACE')"
    :options="options"
    @change="handleChange"
  />
</template>
